var React = require('react');

function RemoveFromFavorite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 6a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v14.191a.5.5 0 0 1-.724.447l-5.052-2.526a.5.5 0 0 0-.448 0l-5.052 2.526A.5.5 0 0 1 6 20.191V6Z","fill":"currentColor"}));
}

RemoveFromFavorite.defaultProps = {"width":"24","height":"24","fill":"none"};

module.exports = RemoveFromFavorite;

RemoveFromFavorite.default = RemoveFromFavorite;
